module.exports = __webpack_public_path__ + "img/fitness-and-recreation-icon.a87a7c7b.svg";